import { apiFetch } from "./config.js";
/** Exchanges an email/password for a bearer token plus the authenticated user. Attach the token via `setAuthToken`. */
export async function login(request, signal) {
    return apiFetch("/auth/login", { method: "POST", body: request, signal });
}
/** Resolves the user a bearer token belongs to - call after `setAuthToken` to hydrate a persisted session on startup. */
export async function getCurrentUser(signal) {
    return apiFetch("/auth/me", { signal });
}
/** Every user account. Admin-only - a 403 from a non-admin caller is expected, not a bug. */
export async function listUsers(signal) {
    return apiFetch("/users", { signal });
}
/** Invites a new user with a temporary password they can change after their first login. Admin-only. */
export async function createUser(request) {
    return apiFetch("/users", { method: "POST", body: request });
}
/** Partial update - only fields present in `request` are changed. Admin-only. */
export async function updateUser(id, request) {
    return apiFetch(`/users/${id}`, { method: "PATCH", body: request });
}
/** Who did what, newest first. Admin-only. */
export async function listAuditLog(params = {}, signal) {
    return apiFetch("/audit-log", {
        query: { action: params.action, actor_email: params.actor_email, limit: params.limit, offset: params.offset },
        signal,
    });
}
